module.exports = "https://cdn-skillquest.mathletics.com/app/164/assets/fonts/e7f249e71a563eed9c495835657eb9c2.ttf";